import { useState } from "react";
import { Button } from "@/components/ui/button";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { IconPicker, getIconByValue } from "@/components/dueDiligence/IconPicker";

interface IconPickerPopoverProps {
  value: string;
  onChange: (value: string) => void;
  size?: "sm" | "md";
}

/** Renders the icon (Phosphor or emoji fallback) */
export const RenderIcon = ({
  value,
  size = 20,
  className = "",
}: {
  value: string;
  size?: number;
  className?: string;
}) => {
  const IconComponent = getIconByValue(value);
  if (IconComponent) {
    return <IconComponent weight="duotone" size={size} className={className} />;
  }
  // Fallback: render as emoji text
  return <span className={className} style={{ fontSize: size * 0.8 }}>{value}</span>;
};

export const IconPickerPopover = ({
  value,
  onChange,
  size = "md",
}: IconPickerPopoverProps) => {
  const [open, setOpen] = useState(false);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="ghost"
          className={`${size === "sm" ? "h-8 w-8" : "h-10 w-10"} p-0 rounded-lg hover:bg-muted/60 flex-shrink-0`}
          title="Kies een icoon"
        >
          <RenderIcon value={value} size={size === "sm" ? 18 : 22} />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[400px] max-h-[400px] overflow-y-auto p-3" align="start" sideOffset={4}>
        <IconPicker
          value={value}
          onChange={(v) => {
            onChange(v);
            setOpen(false);
          }}
          defaultCategory="real_estate"
        />
      </PopoverContent>
    </Popover>
  );
};
